import NftCardLoader from "../../nft-card/nft-card-loader";
import binace from "../../../images/binace-black.png";
import bxArrowIcon from "../../../images/bx-right-top.png";
import { Skeleton } from "@heroui/react";

const CardDetailsPageLoader = () => {
  return (
    <>
      <div className="px-4  max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-8 xl:gap-24 py-8 lg:py-16">
          <div className="lg:w-[50%] xl:w-[40%]">
            <div className="img-wrapper">
              <div className="w-full flex items-center justify-between gap-4 bg-yellowbuy py-2 px-4 rounded-t-2xl">
                <img
                  src={binace}
                  alt="Binance Icon"
                  className="w-8 h-8 object-contain"
                />
                {/* <button
                  className="p-1 rounded-full"
                >
                  <img alt="fav" className="w-8 h-8 object-contain" src={heart} />
                </button> */}
              </div>
              <div className="w-full image-container rounded-b-2xl overflow-hidden">
                <Skeleton className="w-full h-[20rem] lg:h-[30rem]"></Skeleton>
              </div>
            </div>
          </div>
          <div className="lg:w-[50%] xl:w-[60%] relative">
            <div className="flex flex-col gap-2">
              <Skeleton className="max-w-md w-full h-8 rounded-md"></Skeleton>
              <Skeleton className="max-w-xs w-full h-8 rounded-md"></Skeleton>
            </div>
            <div className="flex flex-col gap-2 mt-4">
              <Skeleton className="max-w-md w-full h-4 rounded-md"></Skeleton>
              <Skeleton className="max-w-md w-full h-4 rounded-md"></Skeleton>
              <Skeleton className="max-w-xs w-full h-4 rounded-md"></Skeleton>
            </div>
            <div className="flex items-center gap-2 mt-4">
              <Skeleton className="w-24 h-4 rounded-md"></Skeleton>
              <Skeleton className="w-16 h-3 rounded-md"></Skeleton>
            </div>
            <div className="flex items-center gap-2 mt-8">
              <Skeleton className="w-full max-w-[18.75rem] h-8 rounded-md"></Skeleton>
            </div>

            <div className="flex flex-wrap gap-2 mt-12 max-w-lg">
              <div className="border border-[#C2C2C2] py-2 px-4 rounded-xl flex flex-col gap-2 w-full md:w-[calc(50%-0.5rem)]">
                <Skeleton className="w-24 h-4 rounded-md"></Skeleton>
                <div className="flex items-center gap-2">
                  <div className="icon w-[3rem] h-[3rem]">
                    <Skeleton className="w-full h-full rounded-full"></Skeleton>
                  </div>

                  <div className="w-[calc(100%-3.5rem)]">
                    <Skeleton className="w-full h-4 rounded-md max-w-xs"></Skeleton>
                  </div>
                </div>
              </div>
              <div className="border border-[#C2C2C2] py-2 px-4 rounded-xl flex flex-col gap-2 w-full md:w-[calc(50%-0.5rem)]">
                <Skeleton className="w-24 h-4 rounded-md"></Skeleton>
                <div className="flex items-center gap-2">
                  <div className="icon w-[3rem] h-[3rem]">
                    <Skeleton className="w-full h-full rounded-full"></Skeleton>
                  </div>
                  <div className="w-[calc(100%-3.5rem)]">
                    <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                  </div>
                </div>
              </div>
              <div className="border border-[#C2C2C2] py-2 px-4 rounded-xl flex flex-col gap-2 w-full">
                <Skeleton className="w-24 h-4 rounded-md"></Skeleton>
                <div className="flex items-center gap-2">
                  <div className="icon w-[3rem] h-[3rem]">
                    <Skeleton className="w-full h-full rounded-full"></Skeleton>
                  </div>
                  <div className="w-[calc(100%-3.5rem)] flex flex-col gap-1">
                    <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                    <Skeleton className="w-full h-4 rounded-md"></Skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="related-product_section">
          <div className="flex items-center justify-between gap-4">
            <h1 className="m-0 text-xl sm:text-2xl sm:text-4xl font-semibold text-black uppercase">
              Related Products
            </h1>
            <img
              src={bxArrowIcon}
              className="w-10 h-10 object-contain"
              alt="not-found"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 my-8">
            {[...Array(4)].map((_, index) => (
              <NftCardLoader key={index} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CardDetailsPageLoader;
